const e = [
  "emojiUnicodeOrShortname",
  "isSelected",
  "names",
  "num"
], o = {
  REACTIONS_ATTRIBUTES: e
};
export {
  e as REACTIONS_ATTRIBUTES,
  o as default
};
//# sourceMappingURL=emoji-row-constants.js.map
